import { getObservationFilterDataRequest } from 'api/FHIR/api';
import { ObservationsFilterData } from 'api/FHIR/types';

import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { camelizeKeys } from 'humps';

const useGetFilterData = () => {
  const { t } = useTranslation();

  const [ filterData, setFilterData ] = useState<ObservationsFilterData>({ categoryCodes: [], statuses: [] });
  const [ isLoading, setIsLoading ] = useState<boolean>(false);
  const [ error, setError ] = useState<string>('');

  const getFilterData = useCallback((abortController: AbortController) => {
    setIsLoading(true);
    setError('');

    getObservationFilterDataRequest(abortController)
      .then((response) => {
        setFilterData(camelizeKeys(response.data) as ObservationsFilterData);
      })
      .catch((error) => {
        if (!abortController?.signal.aborted) {
          setError(error?.response?.data?.message || t('errors.server_error_try_again'));
        }
      })
      .finally(() => {
        if (!abortController?.signal.aborted) {
          setIsLoading(false);
        }
      });
  }, [ t ]);

  return { getFilterData, filterData, isLoading, error };
};

export default useGetFilterData;
